import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorService {

  constructor() { }
  public noWhiteSpace(control: UntypedFormControl) {
    if (control.value && control.value.length >= 3 ) {
    const isWhitespace = (control.value).trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
    }
  }
  public isPositiveNumber(control: UntypedFormControl) {
    console.log('control value...........' +  control.value);

   if (control.value !== '') {
    const isPositive = Number(control.value) <= 0 ;
    console.log('isPositive...' + isPositive);
    const isValid = !isPositive;
    return isValid ? null : {'zeroOrnegativeNumber' : true };
   }
}
public isDecimalNumber(control: UntypedFormControl) {
  if (control.value !== '') {
    const isInt = Number(control.value ) % 1 !== 0;
    const isValid = !isInt;
    return isValid ? null : {'decimalNumber': true };

  }

}

}
